import {h, Fragment} from "preact"
import { useAppState, useFacets } from "@nosto/preact"

import SelectedFilters from "./SelectedFilters"
import SortDropdown from "./elements/SortDropdown"
import { useState, useEffect } from "preact/hooks";

export default function Toolbar({ toggleSidebar, setExpandedFacet }) {
    const { response } = useAppState();
    const { facets } = useFacets();
    const docCount = response.products?.total ?? 0;
    const [ topPosition, setTopPosition ] = useState(0);

    useEffect(() => {
        const headerEl = document.getElementById('shopify-section-header');
        if(headerEl) {
            setTopPosition(headerEl.clientHeight);
        }
    }, [])

    return (
        <div className="ns-toolbar sticky bg-white w-full pt-5 lg:pt-8 px-5 lg:px-10" style={`top: ${topPosition}px;`}>
            <div className="w-full flex flex-wrap justify-between">
                <span 
                    className="body-2 lg:hidden" 
                    data-nosto-element="totalResults"
                >
                    {docCount} {(docCount === 1) ? 'product' : 'products'}
                </span>

                <ul className="items-center hidden lg:flex gap-7 mb-7 filter-chosen:mb-8">
                    {facets.map(facet => ((facet.type === 'stats' || facet?.data?.length > 1) &&
                        <li key={facet.field}>
                            <button
                                className="flex items-center body-2 gap-1 after:block after:border-gray-900 after:border-b after:w-1.5 after:h-1.5 after:border-l after:-rotate-45 after:origin-center"
                                type="button"
                                aria-label="Open filters panel"
                                onClick={() => {
                                    toggleSidebar();
                                    setExpandedFacet(facet.field.replaceAll('.', '-').replaceAll(' ', '-'));
                                }}
                            >
                                <span>{facet.name}</span>
                            </button>
                        </li>
                    ))}
                </ul>

                <div className="flex lg:flex-1 justify-end relative lg:items-start pb-5">
                    <button 
                        className="lg:hidden flex items-center body-2 gap-1 after:block after:border-gray-900 after:border-b after:w-1.5 after:h-1.5 after:border-l after:-rotate-45 after:origin-center"
                        type="button"
                        aria-label="Open filters panel"
                        onClick={toggleSidebar}
                    >
                        <span>Filters</span>
                    </button>
                    <SortDropdown />
                    {docCount && (
                        <span 
                            className="hidden body-2 lg:inline lg:relative lg:right-[0px] lg:left-auto"
                            data-nosto-element="totalResults"
                        >
                            {docCount} {(docCount === 1) ? 'product' : 'products'}
                        </span>
                    )}
                </div>
                    
                <SelectedFilters />
            </div>
        </div>
    )
}